(ns practitest.frontend.components2.dashboard.charts.common)

(defn deep-merge [& maps]
  (apply merge-with
         (fn [a b] (if (map? a) (deep-merge a b) b))
         maps))

(defn ensure-el! [parent tag cls]
  (let [sel (.select parent (str tag "." cls))]
    (if (.empty sel)
      (-> parent (.append tag) (.attr "class" cls))
      sel)))

(defn ensure-group! [parent cls]
  (ensure-el! parent "g" cls))

(defn translate! [sel x y]
  (.attr sel "transform" (str "translate(" x "," y ")")))

(defn ensure-style! [svg css]
  (let [sel (.select svg "style.pt-chart")]
    (when (.empty sel)
      (-> svg
          (.append "style")
          (.attr "class" "pt-chart")
          (.text css)))))
